import { render, staticRenderFns } from "./purchaseProjectTaskRequestModal.vue?vue&type=template&id=72802176&scoped=true&"
import script from "./purchaseProjectTaskRequestModal.vue?vue&type=script&lang=js&"
export * from "./purchaseProjectTaskRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./purchaseProjectTaskRequestModal.vue?vue&type=style&index=0&id=72802176&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72802176",
  null
  
)

export default component.exports